import { graphql } from "~/gql";

export const MATTER_LIBRARY_QUERY = graphql(/* GraphQL */ `
  query FindLibraryMatters {
    findAllMatters {
      ...LibraryMatterParts
    }
  }
`);
